<template>
  <div class="info">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="测试名称" prop="title">
        <el-input v-model="ruleForm.title" id="nameinput" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="测试说明" prop="detail">
        <tinymce v-model="ruleForm.detail" style="width: 66%"></tinymce>
      </el-form-item>
      <el-form-item label="重测设置" required prop="repeat_test">
        <el-radio-group v-model="ruleForm.repeat_test">
          <el-radio :label="0">不支持重测</el-radio>
          <el-radio :label="1">邀请
            <input type="number" id="pepnum" v-model="ruleForm.repeat_invite" />
            人重测</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="主图">
        <el-upload :class="['app', 'agent'].indexOf(info.type) >= 0
            ? 'avatar-uploader'
            : 'avatar-uploader'
          " :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest1"
          :before-upload="beforeImageUpload1">
          <img v-if="ruleForm.img_url" :src="ruleForm.img_url" :class="['app', 'agent'].indexOf(info.type) >= 0 ? 'avatar' : 'product'
            " />
          <i v-else :class="['app', 'agent'].indexOf(info.type) >= 0
              ? 'el-icon-plus avatar-uploader-icon'
              : 'el-icon-plus product-uploader-icon'
            "></i>
          <div slot="tip" class="el-upload__tip">
            {{
              ["app", "agent"].indexOf(info.type) >= 0
              ? "只能上传jpg/png文件，且不超过500kb，封面大小 80x80"
              : "只能上传jpg/png文件，且不超过500kb，封面大小 335x144"
            }}
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="虚拟测试人数" prop="virtual_test_num" label-width="130px">
        <el-input type="number" v-model="ruleForm.virtual_test_num" id="XNpepnum"></el-input>
      </el-form-item>
      <el-form-item label="价格">
        <el-radio-group v-model="ruleForm.price">
          <el-radio label="免费"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="赠送体验营设置（仅限体验营课程，支持填写0-3个）" label-width="350px" id="tyyitem">
        <el-radio v-model="ruleForm.give_camp_type" :label="2" class="radio1">支持批量设置</el-radio>
        <el-radio v-model="ruleForm.give_camp_type" :label="1" class="radio1 radio2">仅限单独设置</el-radio>
        <br />
        <el-input type="text" v-model="ruleForm.give_camp_ids[0]" class="tyyID" style="margin-bottom: 5px"></el-input>
        <div class="tyyname" v-if="objects[0]">{{ objects[0].title }}</div>
        <div class="tyytime" v-if="objects[0]">
          {{ objects[0].begin_at }}-{{ objects[0].end_at }}
        </div>
        <br />
        <el-input type="text" v-model="ruleForm.give_camp_ids[1]" class="tyyID" style="margin-bottom: 5px"></el-input>
        <div class="tyyname2" v-if="objects[1]">{{ objects[1].title }}</div>
        <div class="tyytime2" v-if="objects[1]">
          {{ objects[1].begin_at }}-{{ objects[1].end_at }}
        </div>
        <br />
        <el-input type="text" v-model="ruleForm.give_camp_ids[2]" class="tyyID"></el-input>
        <div class="tyyname3" v-if="objects[2]">{{ objects[2].title }}</div>
        <div class="tyytime3" v-if="objects[2]">
          {{ objects[2].begin_at }}-{{ objects[2].end_at }}
        </div>
        <!--   -->
      </el-form-item>
      <el-form-item label="解读老师加微按钮显示" label-width="160px">
        <el-switch v-model="ruleForm.add_wechat" @change="switchHandel" active-color="#13ce66"
          active-text="开启后请填写承接二维码和引导标题，外链加微链接可选填"></el-switch>
      </el-form-item>
      <el-form-item label="承接二维码" class="erweimacode">
        <el-upload :class="['app', 'agent'].indexOf(info.type) >= 0
            ? 'avatar-uploader'
            : 'avatar-uploader'
          " :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest2"
          :before-upload="beforeImageUpload2">
          <img v-if="ruleForm.wechat_img" :src="ruleForm.wechat_img" :class="['app', 'agent'].indexOf(info.type) >= 0 ? 'avatar' : 'product'
            " />
          <i v-else :class="['app', 'agent'].indexOf(info.type) >= 0
              ? 'el-icon-plus avatar-uploader-icon'
              : 'el-icon-plus product-uploader-icon'
            "></i>
        </el-upload>
        <el-input v-model="ruleForm.wechat_title" placeholder="请输入引导标题"
          style="width: 350px; margin-left: 50px"></el-input>
        <div class="wechatcode">
          <img src="https://res.defen.hzxinquanzi.com/activity/assist/859h7vMJTH4wGaMyUTiDG2nIpSI5mKVWo6YWlmB8.png"
            alt="" />
        </div>
      </el-form-item>
      <el-form-item label="外链加微" class="wechatlink">
        <el-input type="text" v-model="ruleForm.miniprogram_url" id="wechatXCX"></el-input>
      </el-form-item>
      <el-form-item label="结果输出方式" class="result" prop="result_type">
        <el-radio-group v-model="ruleForm.result_type">
          <el-radio :label="1" :disabled="testid !== null">随机结果</el-radio>
          <el-radio :label="2" :disabled="testid !== null">以分数为结果</el-radio>
          <el-radio :label="3" :disabled="testid !== null">以选项维度出结果</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="serveForm('ruleForm')" v-if="testid">保存</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-else>立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import { getAliyunOssToken } from "@/api/common";
import {
  getappraisacreate,
  getappraisainfo,
  setappraisaupdate,
} from "@/api/coupon";
import {
  beforeImageUpload as beforeImageUpload1,
  uploadOSSRequest as uploadOSSRequest1,
} from "@/api/common";

import {
  beforeImageUpload as beforeImageUpload2,
  uploadOSSRequest as uploadOSSRequest2,
} from "@/api/common";

export default {
  data() {
    return {
      ossAction: "",
      info: {
        type: "app",
      },
      ruleForm: {
        title: "", // 名字
        result_type: 0, // 结果输出方式
        repeat_test: 0, // 重测设置
        virtual_test_num: "", // 虚拟人数
        detail: "", // 测试说明
        img_url: "", // 主图1
        wechat_img: "", // 二维码
        repeat_invite: null, // 邀请人数
        price: "免费", //价格
        give_camp_ids: [], // 赠送课程id
        add_wechat: false, // 解读加微
        miniprogram_url: "", // 小程序加微链接
        wechat_title: "", // 引导标题
        give_camp_type: 2,
      },
      radiopiliang: 2,
      rules: {
        title: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, max: 30, message: "字数最多为30个", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        result_type: [
          { required: true, message: "请选择一个结果方式", trigger: "change" },
        ],
        repeat_test: [
          { required: true, message: "请选择重测设置", trigger: "change" },
        ],
        virtual_test_num: [
          { required: true, message: "请填写虚拟测试人数", trigger: "blur" },
        ],
        detail: [
          { required: true, message: "请填写测试说明", trigger: "blur" },
        ],
      },
      testid: null,
      objects: [], // 存储接口返回的对象
    };
  },
  mounted() {
    // 获取 URL 哈希
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(hash.indexOf("?") + 1));
    this.testid = params.get("id");
    if (this.testid) {
      this.testInfoHandel();
    }
    console.log(this.testid);
  },
  components: {
    tinymce,
    activityCustomUpload,
  },
  computed: {
    getNameById() {
      return (id) => {
        const obj = this.getObjectById(id);
        return obj ? obj.title : "";
      };
    },
    getbeginTimeById() {
      return (id) => {
        const obj = this.getObjectById(id);
        return obj ? obj.begin_at : "";
      };
    },
    getendTimeById() {
      return (id) => {
        const obj = this.getObjectById(id);
        return obj ? obj.end_at : "";
      };
    },
  },
  methods: {
    switchHandel(value) {
      console.log(value, this.ruleForm.add_wechat);
    },
    submitForm(formName) {
      // 创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm, "ruleform");
          // this.ruleForm.give_camp_ids = JSON.stringify(this.ruleForm.give_camp_ids)
          console.log(this.ruleForm.give_camp_ids, "jsonString");
          this.appraisacreate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    serveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.ruleForm.give_camp_ids = JSON.stringify(
          //   this.ruleForm.give_camp_ids
          // );
          this.appraisaupdate();

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    appraisaupdate() {
      if (this.ruleForm.add_wechat == true) {
        this.ruleForm.add_wechat = 1;
      } else if (this.ruleForm.add_wechat == false) {
        this.ruleForm.add_wechat = 0;
      }
      setappraisaupdate(this.ruleForm).then((res) => {
        console.log(res.data);
        if (res.code == 1) {
          this.$message({
            message: "恭喜你，修改成功",
            type: "success",
          });
          this.$router.push(`/appraisal/list`);
        }
      });
    },
    testInfoHandel() {
      // 非第一次进入 页面信息
      let data = {
        id: this.testid,
      };
      getappraisainfo(data).then((res) => {
        console.log(res);
        this.ruleForm = res.data;
        this.objects = res.data.give_camp_list;
        // if (!Array.isArray(this.objects)) {
        //   [this.objects] = [this.objects];
        // }
        // this.objects = this.objects;
        console.log(this.objects, "this.objects", this.ruleForm);
        res.data.add_wechat == 1
          ? (this.ruleForm.add_wechat = true)
          : (this.ruleForm.add_wechat = false);
      });
    },
    getObjectById(id) {
      return this.objects.find((obj) => obj.id === id);
    },
    appraisacreate() {
      if (this.ruleForm.add_wechat == false) {
        this.ruleForm.add_wechat = 0;
      } else {
        this.ruleForm.add_wechat = 1;
      }

      getappraisacreate(this.ruleForm).then((res) => {
        // console.log(res.data.result_type);
        if (res.code == 1) {
          this.$message({
            message: "保存成功，请手动重新上架",
            type: "success",
          });
          if (this.ruleForm.add_wechat == 1) {
            this.ruleForm.add_wechat = true;
          } else {
            this.ruleForm.add_wechat = false;
          }
          this.$router.push(`/appraisal/list`);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    beforeImageUpload1(file) {
      beforeImageUpload1(file);
    },
    uploadOSSRequest1(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest1(file.file, res.data).then((fileUrl) => {
          this.ruleForm.img_url = fileUrl;
        });
      });
    },
    beforeImageUpload2(file) {
      beforeImageUpload2(file);
    },
    uploadOSSRequest2(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest2(file.file, res.data).then((fileUrl) => {
          this.ruleForm.wechat_img = fileUrl;
        });
      });
    },
  },
};
</script>

<style>
.info {
  width: 100%;
  height: auto;
  padding: 30px;
  box-sizing: border-box;
}

input {
  border: 1px solid #ccc;
  /* background: none; */
  margin: 0;
  padding: 0;
  outline: none;
  /*清除input点击之后的黑色边框*/
}

#nameinput {
  width: 500px;
}

#pepnum {
  width: 100px;
  height: 20px;
}

#XNpepnum {
  width: 100px;
}

.tyyID {
  width: 100px;
}

#tyyitem .el-form-item__content {
  margin-left: 60px !important;
}
#tyyitem {
  position: relative;
}
#tyyitem .radio1{
position: absolute;
left: 300px;
top: 15px;
}
#tyyitem .radio2{
position: absolute;
left: 500px;
top: 15px;
}
.el-form-item__label {
  text-align: left;
}

.tyyname {
  position: absolute;
  width: auto;
  top: 29px;
  left: 115px;
  color: #bbb;
}

.tyytime {
  position: absolute;
  width: auto;
  top: 52px;
  left: 115px;
  color: #bbb;
}

.tyyname2 {
  position: absolute;
  width: auto;
  top: 73px;
  left: 115px;
  color: #bbb;
}

.tyytime2 {
  position: absolute;
  width: auto;
  top: 95px;
  left: 115px;
  color: #bbb;
}

.tyyname3 {
  position: absolute;
  width: auto;
  top: 119px;
  left: 115px;
  color: #bbb;
}

.tyytime3 {
  position: absolute;
  width: auto;
  top: 143px;
  left: 115px;
  color: #bbb;
}

#wechatXCX {
  width: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.demo-ruleForm .avatar {
  width: 178px !important;
  height: 178px;
  display: block;
}

.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.product-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 335px;
  height: 144px;
  line-height: 144px;
  text-align: center;
}

.product {
  width: 335px;
  height: 144px;
  display: block;
}

.erweimacode .el-form-item__content {
  margin-left: 100px;
  display: flex;
  align-items: center;
}

.wechatlink .el-form-item__label {
  width: auto !important;
}

.wechatlink .el-form-item__content {
  margin-left: 120px !important;
}

.result .el-form-item__label {
  width: 117px !important;
}

.wechatcode {
  width: 180px;
  height: 230px;
  margin-left: 50px;
}

.wechatcode img {
  width: 100%;
}
</style>